import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import AccessDenied from '../AccessDenied/AccessDenied';
import Loading from '../Loading/Loading';

export default function ProtectedRoute({ children, permission }) {
  const { hasPermission, isLoaded } = usePermissions();

  if (!isLoaded) {
    return (
      <div className="w-full flex flex-1 items-center justify-center mt-10">
        <Loading />
      </div>
    );
  }

  if (!hasPermission(permission)) {
    return <AccessDenied />;
  }

  return children;
}
